import React, { useEffect, useState } from "react";
import Header from "../../components/appLayout/header";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { ButtonApp } from "../../components/ButtonApp";
import "./index.scss";
import { LinkendinIcon } from "../../assets/icons/LinkendinIcon";
import { XIcon } from "../../assets/icons/XIcon";
import { toast } from "react-toastify";
import SimulationService from "../../service/simulation.service";
import { useLocation } from "react-router-dom";
const simulationService = new SimulationService();
export const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    company: "",
    phone: "",
    email: "",
    position: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName || !formData.email || !formData.message) {
      toast.error("Veuillez remplir les champs obligatoires.");
      return;
    }
    let res;

    res = await simulationService.contactCreate(formData);
    toast.success("Votre message a été envoyé avec succès !");
    setFormData({
      fullName: "",
      company: "",
      phone: "",
      email: "",
      position: "",
      message: "",
    });
  };
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#contact-section") {
      const el = document.getElementById("contact-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div>
      <div className="slide-contact">
        <div className="header-contact pt-5">
          <Header />
        </div>
        <div className="slide-contact-container p-5 px-0 px-md-5">
          <Row className="align-items-center justify-content-center gx-0 h-100 p-5">
            <h1 className="slide-title">Contactez nous</h1>
          </Row>
        </div>
      </div>

      <div id="contact-section" className="contact-section">
        <div className="contact-container">
          <Row className="justify-content-center align-items-center g-5">
            <Col md={7} className="left-form">
              <h2>
                Besoin d’un conseil sur mesure ? <br /> Contactez nos experts.
              </h2>
              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Control
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Nom et prénom *"
                      className="mb-3"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Control
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Nom de l’entreprise / organisation"
                      className="mb-3"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Control
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Numéro de téléphone / WhatsApp"
                      className="mb-3"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Control
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Adresse e-mail professionnelle *"
                      className="mb-3"
                    />
                  </Col>
                </Row>
                <Form.Control
                  name="position"
                  value={formData.position}
                  onChange={handleChange}
                  placeholder="Fonction (ex : gérant, agriculteur, industriel)"
                  className="mb-3"
                />
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message *"
                  className="mb-3"
                />
                <Button type="submit" className="custom-btn">
                  Envoyer
                </Button>
              </Form>
            </Col>

            <Col md={4} className="info-box ms-md-5 ms-0">
              <h5>Adresse</h5>
              <p>Adresse : paris rue 123</p>
              <h5>Contact</h5>
              <p>
                Téléphone: +33 526 985 65 <br /> Email: contact@exemple.com
              </p>
              <h5>Horaires d’ouverture</h5>
              <p>Lundi - Vendredi : 10h00 - 12h00</p>
              <h5>Restez connectés</h5>
              <div className="icons">
                <LinkendinIcon />
                <XIcon />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
